import { BoxProps, TextProps } from '@jfs/ui-new'

export const shadowStyle = {
  shadowColor: 'GRAY_SHADOW',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 0.6,
  shadowRadius: 2,
  elevation: 2,
}

export const styles = {
  container: {
    bg: 'WHITE',
    flexDirection: 'row',
    justify: 'space-between',
    width: '100%',
    pv: 17,
    mb: 1,
    ...shadowStyle,
  } as BoxProps,
  leftContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 15,
    pb: 5,
  } as BoxProps,
  payText: {
    color: 'BLUE',
    fontSize: 15,
    fontWeight: 'bold',
  } as TextProps,
  rightContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
  } as BoxProps,
}
